import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { zSmallestUnitPrice } from '@/schemas/smallestUnitPriceSchema'

import type { SmallestUnitPriceDto as ResponseDto } from '@/gen/bff'
import type { SmallestUnitPriceSchema } from '@/schemas/smallestUnitPriceSchema'

export const smallestUnitPriceConverter = (data: ResponseDto | undefined): SmallestUnitPriceSchema | null => {
  if (!data?.unitName || data.unitPrice == null || data.unitPriceWithVat == null) {
    return null
  }

  const response: SmallestUnitPriceSchema = {
    unitName: data.unitName,
    unitPrice: data.unitPrice,
    unitPriceWithVat: data.unitPriceWithVat,
  }

  return zSmallestUnitPrice.catch(defaultZodCatch).parse(response)
}
